import React from "react";
import { Form, Image, Nav } from "react-bootstrap";
import searchIcon from "../assets/images/icons/search.png";
import companyImage from "../assets/images/icons/CompanyIcon.png";

// Reusable sidebar for company search and selection
// Props:
// - companies: array of { id, accountName }
// - selectedCompanyId: currently selected company id
// - onSelectCompany: function(id)
// - searchTerm: string
// - onSearchTermChange: function(value)
// - companyLogos: map of companyId -> logo url (optional)
// - className: optional wrapper className
const CompanySidebar = ({
  companies = [],
  selectedCompanyId,
  onSelectCompany,
  searchTerm = "",
  onSearchTermChange,
  companyLogos = {},
  className = "",
}) => {
  return (
    <div
      className={className}
      style={{ border: "#E4E4E4 1px solid", borderRadius: "8px" }}
    >
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ padding: "10px" }}
      >
        <div className="position-relative" style={{ width: "100%" }}>
          <Form.Control
            type="text"
            className="form-control"
            placeholder="Search Name"
            value={searchTerm}
            onChange={(e) => onSearchTermChange?.(e.target.value)}
            style={{ width: "100%" }}
          />
          <Image
            style={{ right: "15px", top: "12px" }}
            width={15}
            className="position-absolute"
            src={searchIcon}
          />
        </div>
      </div>
      <div
        className="nav-scroll-container"
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          paddingRight: "0px",
          background: "#F5F5F5",
        }}
      >
        <Nav variant="pills" className="flex-column">
          {companies
            .filter((company) =>
              company.accountName
                ?.toLowerCase()
                .includes((searchTerm || "").toLowerCase())
            )
            .map((company) => (
              <Nav.Item key={company.id}>
                <Nav.Link
                  active={selectedCompanyId === company.id}
                  onClick={() => onSelectCompany?.(company.id)}
                  className="tab-side-nav-link"
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="company-detail w-100 d-flex align-items-center gap-2 justify-content-between">
                      <div className="d-flex align-items-center gap-2">
                        <Image
                          width={30}
                          height={30}
                          style={{
                            border: "1px solid #E4E7EC",
                            borderRadius: "50%",
                          }}
                          src={companyLogos[company.id] || companyImage}
                          alt={company.accountName}
                        />
                        <h6
                          className="text-101828 mb-0 text-capitalize"
                          style={{ fontSize: "13px", fontWeight: 500 }}
                          title={company.accountName}
                        >
                          {company.accountName}
                        </h6>
                      </div>
                    </div>
                  </div>
                </Nav.Link>
              </Nav.Item>
            ))}
        </Nav>
      </div>
    </div>
  );
};

export default CompanySidebar;